var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PaginationComponent',{ref:"pagination",attrs:{"totalItems":_vm.totalItems,"totalPages":_vm.totalPages,"page":_vm.paginationSetting.page,"pageSize":_vm.paginationSetting.pageSize},on:{"on-page-change":_vm.getData}})}
var staticRenderFns = []

export { render, staticRenderFns }